import English from './en.json';
import Hindi from './hi.json';


const LocaleMessages:any = {
    en: English,
    hi: Hindi,
};

export default LocaleMessages;